import ModalLink from 'components/ModalLink'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { Header, RestrictedContent } from './style'
import { Box, styled } from '@mui/material'
import { IconInfo } from 'components/Icons'
import { ReactComponent as IconCN } from './cn.svg'
import { ReactComponent as IconUS } from './us.svg'

const RestrictedAreas = styled('div')`
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 16px;
  margin: 16px 0;
  background: rgba(22, 25, 30, 1);
  border-radius: 4px;
  gap: 32px;

  p {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 0;
  }
`
const Footer = styled(Header)`
  p {
    color: rgba(255, 255, 255, 1);
    a {
      color: rgba(160, 238, 9, 1);
    }
  }
`

export const Restricted = memo(() => {
  return (
    <ModalLink
      width="435px"
      isIn={true}
      hideCloseBtn={true}
      header={<Box sx={{ flex: 1, textAlign: 'center' }}>Restricted</Box>}
    >
      <RestrictedContent>
        <Header>
          <IconInfo style={{ width: '24px', height: '24px' }} />
          <p>
            You are accessing this site from a jurisdiction where our products
            and services are unavailable. We regret that we cannot provide
            services to users in certain locations.
          </p>
        </Header>
        <RestrictedAreas>
          <p>
            <IconCN />
            China
          </p>
          <p>
            <IconUS />
            United States
          </p>
        </RestrictedAreas>
        <Footer>
          <p>
            Please see our <Link to="/restricted/terms">Terms of Use</Link> for
            more details.
          </p>
        </Footer>
      </RestrictedContent>
    </ModalLink>
  )
})
